module.exports = __webpack_public_path__ + "media/noPineapple8.f8df1cba.mp3";